<template>
    <div class="">
        <slide-over-panel v-if="group !== null"
                    v-model:show="$data._show"
                    @update:show="updateShow($data._show)">
            <template #title>
                <div class="flex items-center">
                    <span>Group Information</span>
                </div>
            </template>

            <template #content>


                <div class="mt-4">
                    <span class="text-lg text-gray-900 text-left font-semibold">Group Name</span>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                        <input type="text"
                               name="group-name"
                               id="group-name"
                               v-model="group.name"
                               class="block w-full shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm border-gray-300 rounded-md"/>
                    </div>
                </div>

                <div class="flex flex-col items-start mt-4">
                    <label for="group_description"
                           class="text-lg text-gray-900 text-left font-semibold">Description</label>

                    <div class="mt-1 sm:mt-0 w-full">
                        <textarea id="group_description"
                                  name="group_description"
                                  rows="3"
                                  v-model="group.description"
                                  class="shadow-sm block w-full focus:ring-blue-500 focus:border-blue-500 sm:text-sm border border-gray-300 rounded-md"
                        />
                        <p class="mt-2 text-sm text-gray-500">Descriptions are just here to help you -- they have no
                            impact on the rest of SoniCloud.</p>
                    </div>
                </div>

                <!-- List of zones that the group can access -->
                <div>
                    <span class="text-lg text-gray-900 text-left font-semibold">Zones Visible</span>
                    <div    v-if="groupProp.zones !== null"
                            class="mt-1 sm:mt-0 w-full">
                        <span   v-for="zoneName in groupProp.zones"
                                class="inline-flex items-center m-1 px-2.5 py-0.5 rounded-md text-md font-medium bg-blue-100 text-blue-800">
                            {{ zoneName }}
                        </span>
                    </div>

                    <!-- No Zones -->
                    <div    v-else>
                        <span   class="inline-flex items-center m-1 px-2.5 py-0.5 rounded-md text-md font-medium bg-red-100 text-red-800">
                            No Zones are Currently Assigned
                        </span>
                    </div>

                    <div    class="mt-2 mb-2 text-sm text-gray-500">
                        <span>Need to edit which zones this group can access? Visit the
                            <undecorated-link   :href="company.buildCompanyRoute('groups/permissions')"
                                                class=""
                                                target="_blank">
                                <span   class="underline decoration-dotted text-gray-500 hover:text-gray-700 active:text-gray-500">
                                    Group Permissions Page.
                                </span>
                            </undecorated-link>
                        </span>
                    </div>
                </div>

                <div class="mt-4 pb-4"
                     v-show="$data._show">
                    <span class="text-lg text-gray-900 text-left font-semibold">Users</span>
<!--                  Note: We purposely don't v-model the groupUsersArray, we just v-bind it since it's computed -->
                    <select2
                        :value="groupUsersArray"
                        :options="users"
                        :multiple="true"
                        :name="'usersInGroup'"
                        @input="updateUsersInGroup()"
                    >
                    </select2>
                </div>

                <div v-if="group.name.length > 0" class="">
                    <green-button @click="save"
                    >
                        <div v-if="processing"
                             class="inline-flex">
                            <span class="lnr icon-loading animate-spin" style="font-size: 1.2rem;"></span>
                            <span class="pl-4">Processing</span>
                        </div>
                        <div v-else
                             class="inline-flex">
                            <span>Save Changes</span>
                        </div>

                    </green-button>
                </div>
                <div v-else>
                  <sonicu-button
                    bg-color="bg-gray-100"
                    bg-color-hover="bg-gray-100"
                    text-color="text-gray-800"
                    text-color-hover="text-gray-800"
                  >
                    The group's name cannot be empty
                  </sonicu-button>
                </div>
                <div class="mt-12" v-if="group.id !== null && group.id !== 1">
                    <button-red-primary
                        @click="askToDelete()"
                    >
                        <div class="inline-flex">
                            <span>Delete Group</span>
                        </div>
                    </button-red-primary>
                </div>


            </template>
        </slide-over-panel>

<!--    Notification modal for the results -->
        <notification-modal
            v-model:is-open="showResultModal"
        >
            <template #title-content>
                Update Successful!
            </template>
            {{ modalText }}
        </notification-modal>

        <!--    Notification modal for confirmation, if needed -->
        <notification-modal
            v-model:is-open="showConfirmModal"
            :give-option=true
            :is-error-modal="true"
            v-on:action="trash"
        >
            <template #title-content>
                Are you sure?
            </template>
            Would you really like to delete this group? This may remove users in this group from receiving alarms.
        </notification-modal>
    </div>
</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import SlideOverPanel from '@/components/elements/SlideOverPanel';
import GreenButton from '@/components/elements/green-button';
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
import Select2 from '@/components/elements/select2';
import ButtonRedPrimary from "@/components/elements/buttons/ButtonRedPrimary";
import ButtonAjax from "@/components/elements/buttonAjax";
import NotificationModal from "@/components/elements/NotificationModal";
import SonicuButton from "@/components/elements/buttons/SonicuButton";
import UndecoratedLink from "../EnterpriseDashboard/undecorated-link.vue";

export default {
    name: "GroupsEdit",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {
        UndecoratedLink,
      SonicuButton,
      NotificationModal, ButtonAjax, ButtonRedPrimary, SmallColoredCheck, SlideOverPanel, GreenButton, Select2},
    props: {
        users: Object,
        groupProp: Object,
        show: Boolean,
    },
    data() {
        return {
            _show: this.show,
            group: {
                'name': '',
                'description': '',
                'users': {},
                'id': null,
            },
            usersToSubmit: {},
            processing: false,
            showResultModal: false,
            showConfirmModal: false,
            modalText: '',
        }
    },
    created() {
    },
    mounted() {

    },
    methods: {
        updateShow(show) {
            this.$data._show = show
            this.$emit('update:show', this.$data._show)
        },
        save() {
            this.processing = true;
            if(this.groupProp.id === null){
                this.create();
            } else {
                axios.patch(this.company.buildCompanyApiInternalRoute('groups') + '/' + this.group.id, {
                    name: this.group.name,
                    description: this.group.description,
                    users: this.usersToSubmit,
                }).then(response => {
                        this.isAddingGroup = false;
                        this.modalText = 'Group updated successfully!'
                        this.group.users = this.usersToSubmit;
                        this.showResultModal = true;
                        this.$emit('update:group', this.group);
                        this.processing = false;
                    }
                ).catch(error => {
                    this.processing = false;
                })
            }

        },
        create() {
            this.processing = true;
            axios.post(this.company.buildCompanyApiInternalRoute('groups'), {
                group_name: this.group.name,
                group_description: this.group.description,
                users: this.usersToSubmit,
            }).then(response => {
                    this.isAddingGroup = true;
                this.modalText = 'Group created successfully!'
                    this.group.users = this.usersToSubmit;
                    this.showResultModal = true;
                    this.$emit('create:group', this.group);
                    this.processing = false;
                }
            ).catch(error => {
                this.processing = false;
            });
        },
        askToDelete(){
            this.showConfirmModal = true;
        },
        trash(shouldTrash) {
            if (! shouldTrash) {
                return
            }

            this.processing = true;
            axios.delete(this.company.buildCompanyApiInternalRoute('groups') + '/' + this.group.id, {
                group_name: this.group.name,
                group_description: this.group.description,
                users: this.usersToSubmit,
            }).then(response => {
                    this.isAddingGroup = true;
                this.modalText = 'Group deleted successfully!'
                    this.group.users = this.usersToSubmit;
                    this.showResultModal = true;
                    this.$emit('create:group', this.group);
                    this.processing = false;
                }
            ).catch(error => {
                this.processing = false;
            });
        },
        updateUsersInGroup() {
            let newGroupUsers = {};
            let elementName = "usersInGroup"
            let val = $('[name=' + elementName + ']').val()
            val.forEach((item, key) => {
                newGroupUsers[item] = parseInt(item)
            })
            this.usersToSubmit = newGroupUsers;
        },
    },
    computed: {
        groupUsersArray() {
            return _.values(this.groupProp.users);
        }
    },
    watch: {
        show() {
            this.$data._show = this.show;
        },
        groupProp: function (newVal, oldVal) {
            console.log('updating');
            this.group = _.clone(newVal);
        },
        showResultModal: function(newVal, oldVal) {
            if(newVal === false){
                this.updateShow(false);
            }
        }
    },
}

</script>

<style scoped>

</style>